import { AppUtils } from '../../../app.utils';
import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'ba-multi-hierarchy-dropdown',
  templateUrl: './multi-hierarchy-dropdown.component.html'
})

export class MultiHierarchyDropdownComponent {
  clonedselectedLocationId: Array<any> = [];
  isOpened = false;
  finalData: Array<any> = [];
  constructor(public appUtils: AppUtils) {}

  @Input() finalResultLocation: any = [];
  @Input() finalList: any = [];
  @Input() selectedDropdownLocationValue: any = [];
  @Input() selectedLocationId: any = [];
  @Input() isDropdownRequired = true;
  @Output() outputDataResult = new EventEmitter();

  ngAfterViewInit() {
    const that = this;
    $('.location-dropdown-complete dt').click(function (e) {
      if ($(this).siblings('dd').hasClass('displaynone')) {
        $(this).siblings('dd').removeClass('displaynone');
        that.clonedselectedLocationId = JSON.parse(JSON.stringify(that.selectedLocationId))
        that.isOpened = true;
      } else {
        $(this).siblings('dd').addClass('displaynone');
        that.outputData();
        that.isOpened = false;
      }
    });


    $(document).bind('click', function (e) {
      if (that.isOpened && !$(e.target).parents().hasClass('location-dropdown-complete')) {
        $('.location-dropdown-complete dd').addClass('displaynone');
        that.isOpened = false;
        that.outputData();
      }
    });
  }

  nodeSelect(event, type, file) {
    this.selectedLocationId = [];
    const temp = this.appUtils.nodeSelection(file, this.selectedLocationId,
      this.finalList, this.selectedDropdownLocationValue, event, type);
    this.selectedLocationId = temp.locationId;
    this.selectedDropdownLocationValue = temp.locationLabel;
    this.finalList = temp.finalList;
  }

  outputData() {
    $('.location-dropdown-complete dd').addClass('displaynone');
    this.isOpened = false;
    for (let i = 0; i < this.selectedLocationId.length; i++) {
      if (!this.selectedLocationId[i]) {
        this.selectedLocationId.splice(i, 1);
      }
    }
    if (!this.selectedLocationId.length && this.isDropdownRequired) {
      this.appUtils.showToasterMessage('error', 'Please select atleast one location', '');
    }

    if (!this.appUtils.isMultiHierarchySameSelected(this.selectedLocationId, this.clonedselectedLocationId)) {
      this.outputDataResult.emit({ locationId: this.selectedLocationId, locationName: this.selectedDropdownLocationValue });
    }
  }
}
